module.exports = __webpack_public_path__ + "static/media/xiconn.9c490a5f.svg";